import {useMemo} from 'react';

const useMenuOptions = (auth, collapsedDomains = [], options = {}) => {
  const {successFormula, googleProperties} = options;

  return useMemo(() => {
    if (!auth?.menu?.menu?.[1]) {
      return [];
    }

    // If successFormula is true, return the special menu structure
    if (successFormula) {
      let menu = [];

      if (!googleProperties) {
        return menu;
      }

      googleProperties.connected.map((property, i) => {
        menu.push({
          assignedProperty: property.assignedProperty[0].property,
          label: property.name,
          value: {
            publisher: auth.menu.menu[1].children.filter(
              domain => domain.path[2] === property.id
            )[0].path[1],
            domain: property.id,
            placement: null,
          },
        });
      });

      return menu;
    }

    let menu = [];

    // Add the total/inventory option
    menu.push({
      label: 'Inventory',
      value: {
        publisher: null,
        domain: null,
        placement: null,
      },
    });

    // Process domains and placements
    auth.menu.menu[1].children
      .filter(item => item.data?.menu?.title)
      .map((domain, i) => {
        // Add domain option
        menu.push({
          label: `${domain.data.menu.alias} domain`,
          adUnits: domain.children.map(placement => placement.path),
          value: {
            publisher: domain.path[1],
            domain: domain.path[2],
            placement: null,
          },
        });

        // Add placement options if domain is not collapsed
        if (!collapsedDomains.includes(domain.path[2])) {
          domain.children.map(placement => {
            if (placement.data.menu.length !== 0) {
              menu.push({
                label: `${domain.data.menu.alias} ${placement.data.menu.title}`,
                value: {
                  publisher: domain.path[1],
                  domain: domain.path[2],
                  placement: placement.path,
                },
                customAdditionalLabel: domain.data.menu.alias,
                // Preserve parentid from the raw menu data
                parentid: placement.parentid,
                path: placement.path, // Also preserve the path for parent matching
              });
            }
          });
        }
      });

    return menu;
  }, [auth, collapsedDomains, successFormula, googleProperties]);
};

export default useMenuOptions;
